module.exports = __webpack_public_path__ + "img/noun-resilience-5370812.416a56d8.svg";